const NIPIGE_BASE_URL = "https://live.app.fastforge.ai";

const NIPIGE_CAP = `${NIPIGE_BASE_URL}/cap`;
const NIPIGE_CATALOG = `${NIPIGE_BASE_URL}/catalog`;
const NIPIGE_INVENTORY = `${NIPIGE_BASE_URL}/store`;
const NIPIGE_ORDER = `${NIPIGE_BASE_URL}/order`;
const NIPIGE_ADVERTISEMENT = `${NIPIGE_BASE_URL}/advertisement`;
const NIPIGE_STORAGE = `${NIPIGE_BASE_URL}/storage`;
const NIPIGE_RBAC = `${NIPIGE_BASE_URL}/rbac`;
const NIPIGE_CHECKOUT = `${NIPIGE_BASE_URL}/checkout`;
const NIPIGE_SUBSCRIBE = `${NIPIGE_BASE_URL}/subscription-payments`;
const NIPIGE_BULKIMPORT = `${NIPIGE_BASE_URL}/bulk-upload`;
const NIPIGE_BUCKET_BASEURL = "https://fastforge-prod.s3.amazonaws.com";
const GOOGLE_MAP_KEY = "AIzaSyB8p-UFwYyJ4tUhksQTmnWFjAovhRY9N3c";
const PAYTM_MID = "sgCBVB10729254640019";
const PAYTM_URL = "https://securegw-stage.paytm.in";
const WORKFLOW_API = "https://workflow-server.app.nipige.com";
const WORKFLOW_UI = "https://workflow-ui.app.nipige.com";
const EDITOR_URL = "https://editor.fastforge.ai/";
const STRIPE_PUBLISHABLE_KEY = "pk_live_51RLV1DFbTI0rWFhhIG3EGBKzg5MdhAJqGj1bNA3D5JOcDBfvigUKTmnPw7SpXnW7MPEUhyL9ZkX9UdUsSMcHHvCJ00aDTvL46s";

export {
  NIPIGE_BASE_URL,
  NIPIGE_ADVERTISEMENT,
  NIPIGE_BUCKET_BASEURL,
  NIPIGE_CAP,
  NIPIGE_CATALOG,
  NIPIGE_ORDER,
  NIPIGE_RBAC,
  NIPIGE_CHECKOUT,
  NIPIGE_STORAGE,
  NIPIGE_INVENTORY,
  NIPIGE_BULKIMPORT,
  GOOGLE_MAP_KEY,
  NIPIGE_SUBSCRIBE,
  PAYTM_MID,
  PAYTM_URL,
  WORKFLOW_API,
  WORKFLOW_UI,
  EDITOR_URL,
  STRIPE_PUBLISHABLE_KEY
};
